export default __webpack_public_path__ + "static/media/icon.a3203f1d.png";